/* ==========================================================================
   Pellington size sheet. 16 Oct 2026.
   Owner-approved mock: design canvas "Pellington size picking".

   For a product with more than one size, nothing is pre-picked any more. Tapping
   Add to Bag on the product page (or the sticky bar), or Choose size on any card,
   opens one sheet: the sizes, a Size guide that opens in place, then Add to Bag.

   Pieces:
     snippets/pell-size-sheet-shell.liquid   the <dialog> (once per page)
     sections/pell-size-sheet.liquid         the content, fetched per product:
                                             <product url>?section_id=pell-size-sheet
     snippets/buy-buttons.liquid             data-pell-ss-url on the PDP product-form
     snippets/quick-add.liquid               data-pell-ss-open on card buttons

   Adding uses the theme's own <product-form> inside the sheet, so the bag drawer,
   analytics and errors behave exactly as on the product page. When the theme fires
   cart:update the sheet closes and the drawer opens over it.
   ========================================================================== */
(function () {
  'use strict';
  if (window.__pellSizeSheet) return;

  var dlg = document.getElementById('PellSizeSheet');
  var supported = !!(dlg && typeof dlg.showModal === 'function' && window.fetch && window.DOMParser);

  if (!supported) {
    /* Very old browsers: let the product page add as before, and send card
       buttons to the product page instead. */
    window.__pellSizeSheet = 'off';
    document.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('[data-pell-ss-open]');
      if (t) location.href = t.getAttribute('data-pell-ss-open');
    });
    return;
  }
  window.__pellSizeSheet = true;

  var panel = dlg.querySelector('[data-pell-ssd-panel]');
  var cache = {};
  var opener = null;
  var busy = false;

  function sheetUrl(u) {
    var x = new URL(u, location.origin);
    x.searchParams.delete('variant');
    x.searchParams.set('section_id', 'pell-size-sheet');
    return x.pathname + x.search;
  }

  function load(u) {
    var k = sheetUrl(u);
    if (!cache[k]) {
      cache[k] = fetch(k, { credentials: 'same-origin' }).then(function (r) {
        if (!r.ok) throw new Error('size sheet ' + r.status);
        return r.text();
      });
      cache[k].catch(function () { delete cache[k]; });
    }
    return cache[k];
  }

  function lockScroll() {
    document.body.style.overflowY = 'hidden';
  }
  function unlockScroll() {
    /* Keep the page locked if a theme drawer (bag, menu) is still open underneath. */
    if (!document.querySelector('[data-modal="true"] dialog[open]')) document.body.style.overflowY = '';
  }

  function close() {
    if (dlg.open) dlg.close();
  }

  function open(u, trigger) {
    if (busy || !u) return;
    busy = true;
    if (trigger && trigger.classList) trigger.classList.add('loading');
    load(u)
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var node = doc.querySelector('[data-pell-ss]');
        if (!node) throw new Error('size sheet: empty');
        node = document.adoptNode(node);
        panel.classList.remove('is-in');
        panel.replaceChildren(node);
        bind(node);
        opener = trigger || document.activeElement;
        if (!dlg.open) dlg.showModal();
        lockScroll();
        panel.scrollTop = 0;
        requestAnimationFrame(function () {
          requestAnimationFrame(function () { panel.classList.add('is-in'); });
        });
      })
      .catch(function () {
        /* Anything unexpected: the product page still works. */
        location.href = u;
      })
      .then(function () {
        busy = false;
        if (trigger && trigger.classList) trigger.classList.remove('loading');
      });
  }

  function bind(root) {
    var T = root.dataset;
    var chips = Array.prototype.slice.call(root.querySelectorAll('.pell-ss__chip'));
    var form = root.querySelector('product-form');
    var input = root.querySelector('product-form input[name="id"]');
    var msg = root.querySelector('[data-pell-ss-msg]');
    var picked = root.querySelector('[data-pell-ss-picked]');
    var guideBtn = root.querySelector('[data-pell-ss-guide]');
    var guide = root.querySelector('.pell-ss__guide');
    var bis = root.querySelector('[data-pell-ss-bis]');

    function say(text, cls) {
      msg.textContent = text || '';
      msg.className = 'pell-ss__msg' + (cls ? ' ' + cls : '');
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        chips.forEach(function (c) {
          c.setAttribute('aria-pressed', c === chip ? 'true' : 'false');
          c.classList.remove('is-nudge');
        });
        if (picked) picked.textContent = chip.getAttribute('data-label');
        if (guide) {
          guide.querySelectorAll('tr[data-gs-v]').forEach(function (tr) {
            tr.classList.toggle('is-on', tr.getAttribute('data-gs-v') === chip.getAttribute('data-k'));
          });
        }
        if (chip.getAttribute('data-a') === '1') {
          input.value = chip.getAttribute('data-id');
          form.hidden = false;
          bis.hidden = true;
          var q = parseInt(chip.getAttribute('data-q') || '0', 10);
          if (q > 0 && q <= 3) say(T.tUrgent.replace('[n]', q), 'is-urgent');
          else if (q > 0) say(T.tLow.replace('[n]', q), 'is-low');
          else say('');
        } else {
          input.value = '';
          form.hidden = true;
          showBis(chip.getAttribute('data-id'));
          say('');
        }
      });
    });

    if (guideBtn && guide) {
      guideBtn.addEventListener('click', function () {
        var opening = guide.hidden;
        guide.hidden = !opening;
        guideBtn.setAttribute('aria-expanded', opening ? 'true' : 'false');
        var sign = guideBtn.querySelector('span');
        if (sign) sign.textContent = opening ? '−' : '+';
      });
    }

    /* Add to Bag before a size is picked: ask for one, add nothing. Runs in the
       capture phase so the theme's product-form never sees the submit. */
    root.addEventListener('submit', function (e) {
      if (!form.contains(e.target)) return;
      if (input.value) return;
      e.preventDefault();
      e.stopPropagation();
      say(T.tPick, 'is-nudge');
      chips.forEach(function (c) { if (c.getAttribute('data-a') === '1') c.classList.add('is-nudge'); });
    }, true);

    root.querySelector('[data-pell-ss-close]').addEventListener('click', close);

    /* ---- back in stock, for a sold-out size (same endpoint as pell-back-in-stock) ---- */
    var bisForm = bis.querySelector('form');
    var bisInput = bis.querySelector('input[type="email"]');
    var bisBtn = bis.querySelector('button[type="submit"]');
    var bisMsg = bis.querySelector('[data-pell-ss-bis-msg]');
    var bisIdle = bisBtn.textContent;

    function bisSay(text, ok) {
      bisMsg.textContent = text || '';
      bisMsg.className = 'pell-ss__bis-msg' + (text ? (ok ? ' is-ok' : ' is-err') : '');
    }
    function showBis(variantId) {
      bis.hidden = false;
      if (bis.getAttribute('data-variant') !== variantId) {
        bis.setAttribute('data-variant', variantId);
        bisForm.style.display = '';
        bisBtn.disabled = false;
        bisBtn.textContent = bisIdle;
        bisSay('');
      }
    }
    bisForm.addEventListener('submit', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var email = (bisInput.value || '').trim();
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
        bisSay(T.tEmail, false);
        bisInput.focus();
        return;
      }
      var variantId = bis.getAttribute('data-variant');
      bisBtn.disabled = true;
      bisBtn.textContent = '...';
      var body = new URLSearchParams();
      body.set('a', 'Xjhyu7');
      body.set('email', email);
      body.set('variant', variantId);
      body.set('product', T.product);
      body.set('platform', 'shopify');
      fetch('https://a.klaviyo.com/onsite/components/back-in-stock/subscribe', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded', Accept: 'application/json' },
        body: body.toString()
      })
        .then(function (r) { return r.json().catch(function () { return { success: r.ok }; }); })
        .then(function (d) {
          if (d && d.success) {
            bisForm.style.display = 'none';
            bisSay(T.tSent, true);
          } else {
            bisBtn.disabled = false;
            bisBtn.textContent = bisIdle;
            bisSay(T.tFail, false);
          }
        })
        .catch(function () {
          bisBtn.disabled = false;
          bisBtn.textContent = bisIdle;
          bisSay(T.tFail, false);
        });
    });
  }

  /* ---- dialog behaviour ---- */
  dlg.addEventListener('close', function () {
    panel.classList.remove('is-in');
    unlockScroll();
    if (opener && opener.focus && document.contains(opener)) {
      try { opener.focus({ preventScroll: true }); } catch (e) { opener.focus(); }
    }
    opener = null;
  });
  /* A tap on the dimmed area (the dialog itself, outside the panel) closes it. */
  dlg.addEventListener('click', function (e) {
    if (e.target === dlg) close();
  });
  /* Added: the theme now opens the bag drawer. */
  document.addEventListener('cart:update', function () {
    if (dlg.open) close();
  });
  document.addEventListener('cart:error', function (e) {
    if (!dlg.open) return;
    var root = panel.querySelector('[data-pell-ss]');
    var m = panel.querySelector('[data-pell-ss-msg]');
    if (!root || !m) return;
    m.textContent = (e.detail && e.detail.message) || root.dataset.tErr;
    m.className = 'pell-ss__msg is-urgent';
  });

  /* ---- what opens it ---- */
  /* Cards, bag suggestion, wishlist: any element with data-pell-ss-open="<product url>". */
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-pell-ss-open]');
    if (!t) return;
    e.preventDefault();
    e.stopPropagation();
    open(t.getAttribute('data-pell-ss-open'), t);
  });
  /* Start loading on touch, so the sheet is usually ready by the time the tap ends. */
  document.addEventListener('pointerdown', function (e) {
    var t = e.target.closest && e.target.closest('[data-pell-ss-open]');
    if (t) load(t.getAttribute('data-pell-ss-open')).catch(function () {});
  }, { passive: true });

  /* Product page: Add to Bag (and the sticky bar, which clicks it) on a sized product. */
  document.addEventListener('submit', function (e) {
    var pf = e.target.closest && e.target.closest('product-form[data-pell-ss-url]');
    if (!pf) return;
    e.preventDefault();
    e.stopPropagation();
    open(pf.getAttribute('data-pell-ss-url'), pf.querySelector('[type="submit"]'));
  }, true);

  var pdp = document.querySelector('product-form[data-pell-ss-url]');
  if (pdp) {
    var pdpUrl = pdp.getAttribute('data-pell-ss-url');
    /* A tap that landed before this script ran (see the guard in buy-buttons.liquid). */
    if (window.__pellSsQueued) {
      window.__pellSsQueued = null;
      open(pdpUrl, pdp.querySelector('[type="submit"]'));
    } else {
      var warm = function () { load(pdpUrl).catch(function () {}); };
      if ('requestIdleCallback' in window) window.requestIdleCallback(warm, { timeout: 3000 });
      else setTimeout(warm, 1500);
    }
  }
})();
